import React, { useState, useEffect } from "react";
import { useNavigate ,Link} from "react-router-dom";
import { Table } from "antd";
import Axios from "axios";
import { API_BASE_URL } from "../../Config"; // adjust if needed
import SpinLoader from "../loader/SpinLoader";

const CustomerRewardPoints = () => {
  const [userDataSession, setUserDataSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rewardData, setRewardData] = useState([]);
  const navigate = useNavigate();

  // Get OrgId from session
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.warn("No user data in session → redirecting to login");
      navigate("/");
    }
  }, [navigate]);

  // Fetch reward points data when OrgId is available
  useEffect(() => {
    if (!userDataSession?.OrgId) return;

    const fetchRewardPoints = async () => {
      setLoading(true);
      try {
        const response = await Axios.get(
          `${API_BASE_URL}Customer/getAllCustPoints?OrgId=${userDataSession.OrgId}`
        );

        if (response.data?.ResultData) {
          setRewardData(response.data.ResultData);
        } else {
          console.error("No ResultData in response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching customer reward points:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRewardPoints();
  }, [userDataSession]);

  const columns = [
    {
      title: "Customer",
      dataIndex: "CustomerName",
      sorter: (a, b) => a.CustomerName.localeCompare(b.CustomerName),
    },
    {
      title: "Mobile",
      dataIndex: "CustomerMobile",
    },
    {
      title: "Available Points",
      dataIndex: "AvailablePoints",
      sorter: (a, b) => a.AvailablePoints - b.AvailablePoints,
      render: (points) => (
        <span
          style={{ fontWeight: 600, color: points > 0 ? "#28a745" : "#6c757d" }}
        >
          {points}
        </span>
      ),
    },
    {
      title: " Redeemed ",
      dataIndex: "LastRedeemedPoints",
      render: (value) => (value !== null ? value : "-"),
    },
    {
      title: "Last Redeemed On",
      dataIndex: "LastRedeemedDateTime",
      render: (date) => (date ? new Date(date).toLocaleString("en-IN") : "-"),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Customer Reward Points</h4>
              <h6>View available points and redemption history</h6>
            </div>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <div className="d-flex align-items-center">
                  <div className="search-path"></div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              {loading ? (
                <div className="text-center py-5">
                  <SpinLoader />
                </div>
              ) : rewardData && rewardData.length > 0 ? (
                <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={rewardData}
                  rowKey="CustomerId"
                  pagination={{ pageSize: 10 }}
                />
              ) : (
                <div className="text-center p-5 text-muted">
                  No reward points data available for this organization.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRewardPoints;
